import { createSlice } from "@reduxjs/toolkit";

export const sellingPricesListSlice = createSlice({
  name: "sellingPricesList",
  initialState: {
    byId: {},
    allIds: [],
    totalRecords: 0,
    selectedSellingPrice: null,
    filteredRecords: 0,
    isSingleComapnyLoading: false,
    isLoading: false,
  },
  reducers: {
    setAllSellingPricesLoadingState: (state, action) => {
      state.isLoading = true;
    },
    setSingleSellingPriceLoadingState: (state, action) => {
      state.isSingleSellingPriceLoading = true;
    },
    loadAllSellingPrices: (state, action) => {
      const listObj = {};
      action.payload.sellingPrices.forEach((value) => {
        listObj[value.id] = value;
      });
      state.byId = listObj;
      state.allIds = action.payload.sellingPrices.map((value) => value.id);
      state.totalRecords = action.payload.totalRecords;
      state.filteredRecords = action.payload.filteredRecords;
      state.isLoading = false;
    },
    loadSingleSellingPrice: (state, action) => {
      state.selectedSellingPrice =
        action.payload && action.payload.length === 1
          ? action.payload[0]
          : null;
      state.isSingleSellingPriceLoading = false;
    },
  },
});

export const {
  setAllSellingPricesLoadingState,
  setSingleSellingPriceLoadingState,
  loadAllSellingPrices,
  loadSingleSellingPrice,
} = sellingPricesListSlice.actions;

export default sellingPricesListSlice.reducer;
